import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/discussion/comment/styles.scss';export default {
  "comment": "_comment_n9o6p_1",
  "iconBox": "_iconBox_n9o6p_11",
  "author": "_author_n9o6p_15",
  "avatar": "_avatar_n9o6p_25",
  "column": "_column_n9o6p_32",
  "name": "_name_n9o6p_36",
  "role": "_role_n9o6p_42",
  "main": "_main_n9o6p_47",
  "submissionDate": "_submissionDate_n9o6p_56",
  "content": "_content_n9o6p_61",
  "replyButton": "_replyButton_n9o6p_134",
  "icon": "_icon_n9o6p_11",
  "pending": "_pending_n9o6p_162",
  "replies": "_replies_n9o6p_166"
};